import { PATHS } from "config/paths";
import React from "react";
import { useTranslation } from "react-i18next";

const ErrorAddBank = () => {
  const { t } = useTranslation();
  return (
    <div>
      <p>{t("quote.error_message_bank")}</p>
      <div>
        <a
          href={PATHS.CONFIGURATION}
          style={{
            textDecoration: "underline",
            fontWeight: "bold",
            color: "#333",
          }}>
          {t("quote.error_add_bank")}
        </a>
      </div>
    </div>
  );
};

export default ErrorAddBank;
